export default "__VITE_ASSET__Cb88jenl__"